import { render, staticRenderFns } from "./BasicCheckbox.vue?vue&type=template&id=c4f478ce&"
import script from "./BasicCheckbox.vue?vue&type=script&lang=js&"
export * from "./BasicCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports